module.exports = __webpack_public_path__ + "static/media/ger-flag.0f725e97.svg";